"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalClaimStatus = exports.InternalClaimStatus = void 0;
var InternalClaimStatus;
(function (InternalClaimStatus) {
    InternalClaimStatus[InternalClaimStatus["SavedDraft"] = 1] = "SavedDraft";
    InternalClaimStatus[InternalClaimStatus["Cancelled"] = 2] = "Cancelled";
    InternalClaimStatus[InternalClaimStatus["New"] = 3] = "New";
    InternalClaimStatus[InternalClaimStatus["ReviewRequired"] = 4] = "ReviewRequired";
    InternalClaimStatus[InternalClaimStatus["InProgress"] = 5] = "InProgress";
    InternalClaimStatus[InternalClaimStatus["Pending"] = 6] = "Pending";
    InternalClaimStatus[InternalClaimStatus["Declined"] = 7] = "Declined";
    InternalClaimStatus[InternalClaimStatus["ApprovedAuto"] = 8] = "ApprovedAuto";
    InternalClaimStatus[InternalClaimStatus["ApprovedManual"] = 9] = "ApprovedManual";
    InternalClaimStatus[InternalClaimStatus["NoClaimPayable"] = 10] = "NoClaimPayable";
    InternalClaimStatus[InternalClaimStatus["ClaimPaymentInProgress"] = 11] = "ClaimPaymentInProgress";
    InternalClaimStatus[InternalClaimStatus["Paid"] = 12] = "Paid";
    InternalClaimStatus[InternalClaimStatus["PaymentFailed"] = 13] = "PaymentFailed";
    InternalClaimStatus[InternalClaimStatus["RefundRequested"] = 14] = "RefundRequested";
    InternalClaimStatus[InternalClaimStatus["CmhcReimbursed"] = 15] = "CmhcReimbursed";
    // Cancelled = 16,  // Need to check
})(InternalClaimStatus = exports.InternalClaimStatus || (exports.InternalClaimStatus = {}));
var ExternalClaimStatus;
(function (ExternalClaimStatus) {
    ExternalClaimStatus[ExternalClaimStatus["SavedDraft"] = 1] = "SavedDraft";
    ExternalClaimStatus[ExternalClaimStatus["Cancelled"] = 2] = "Cancelled";
    ExternalClaimStatus[ExternalClaimStatus["New"] = 3] = "New";
    ExternalClaimStatus[ExternalClaimStatus["InProgress"] = 4] = "InProgress";
    ExternalClaimStatus[ExternalClaimStatus["Declined"] = 5] = "Declined";
    ExternalClaimStatus[ExternalClaimStatus["Paid"] = 6] = "Paid";
    ExternalClaimStatus[ExternalClaimStatus["NoClaimPayable"] = 7] = "NoClaimPayable";
    ExternalClaimStatus[ExternalClaimStatus["RefundRequested"] = 8] = "RefundRequested";
    ExternalClaimStatus[ExternalClaimStatus["CMHCReimbursed"] = 9] = "CMHCReimbursed";
})(ExternalClaimStatus = exports.ExternalClaimStatus || (exports.ExternalClaimStatus = {}));
